import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';
import { route as DASHBOARD_ROUTE } from '../../features/dashboard';

const UnauthenticatedRoute = (props) => {
  const loggedIn = useSelector((state) => state.session.loggedIn);
  const targetRoute = props.to || DASHBOARD_ROUTE;

  return !loggedIn ? ( <> {props.children}</>) : (<Navigate to={targetRoute} />);
}

export default UnauthenticatedRoute;
